import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple } from '@fuse';

import { Button, Paper, MenuItem, Radio, Typography, Divider } from 'material-ui';
import Select from 'react-select';
import 'react-select/dist/react-select.css'
import TextField from 'material-ui/TextField';
import ReactTable from "react-table";
import Loader from "other-components/loader/loader";
import printjs from 'print-js';
import axios from 'axios';
import $ from "jquery";

import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle,
} from 'material-ui/Dialog';
import DayPickerInput from 'react-day-picker/DayPickerInput';

import { withAlert } from 'react-alert';

import ExpansionPanel, {
    ExpansionPanelDetails,
    ExpansionPanelSummary,
} from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    layoutRoot: {},

});



class BalanceSheet extends Component {

    state = {
        value: 0
    };

    constructor(props) {
        super(props);

        this.state = {

            transactionDate: '',
            expanded: '',
            assetA: [],
            liabilityA: [],
            equityA: [],
            totalAsset: 0,
            totalLiability: 0,
            totalEquity: 0,

        };

        this.loadCurrentDate();

        this.handleTransactionDateChange = this.handleTransactionDateChange.bind(this);

    }

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    // get current date
    loadCurrentDate() {
        var date = new Date();
        var formatedDate = (date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()).toString();
        this.setState({ transactionDate: formatedDate });
    }

    // set transaction date
    handleTransactionDateChange(date) {

        this.setState({ transactionDate: date });
    }


    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    // get balance sheet
    getBalanceSheet() {
        this.setState({ loading: true });
        var dateObj = {
            fromDate: '2018-01-01',
            toDate: this.state.transactionDate
        };

        if (null == this.state.transactionDate || undefined == this.state.transactionDate || '' == this.state.transactionDate) {
            this.setState({ loading: false });
            this.props.alert.error("No Date selected !");

        } else {

            // axios.post('http://localhost:5009/balanceSheet/getBalanceSheet', dateObj)
            axios.post(window.accountServer + '/balanceSheet/getBalanceSheet', dateObj)
                .then(response => {
                    if (null == response || undefined == response || 0 == response.data.detailObj.length) {

                        this.setState({ loading: false });
                    } else {
                        if (response.data.success) {

                            var assetA = [];
                            var totalAsset = 0;
                            for (var i = 0; i < response.data.detailObj.asset.length; i++) {

                                // totalAsset = totalAsset + sum;
                                console.log("DR ", response.data.detailObj.asset[i].DR_SUM);
                                console.log("CR ", response.data.detailObj.asset[i].CR_SUM);

                                var dr = response.data.detailObj.asset[i].DR_SUM;
                                var cr = response.data.detailObj.asset[i].CR_SUM;

                                if (null == dr || '' == dr || undefined == dr) {
                                    dr = 0;
                                } else {
                                    dr = response.data.detailObj.asset[i].DR_SUM;
                                }

                                if (null == cr || '' == cr || undefined == cr) {
                                    cr = 0;
                                } else {
                                    cr = response.data.detailObj.asset[i].CR_SUM;
                                }

                                var sum = parseFloat(dr) - parseFloat(cr);
                                totalAsset = totalAsset + sum;

                                assetA.push(
                                    <div className="w-full">

                                        <div className="w-full">
                                            <ExpansionPanel expanded={this.state.expanded === 'panel1'} onChange={this.handleChange('panel1')}>
                                                <ExpansionPanelSummary className="emp-reg-expand-color-2">
                                                    <Typography className="{classes.heading} flex flex-wrap">
                                                        <label>{response.data.detailObj.asset[i].ACCOUNT_CATEGORY_NAME}</label>
                                                        <strong className="ml-16">{response.data.detailObj.asset[i].NAME}</strong></Typography>
                                                    <Typography className="{classes.secondaryHeading} ml-64">{sum}</Typography>
                                                </ExpansionPanelSummary>
                                                {/* <ExpansionPanelDetails>
                                                    <Typography>
                                                        <div>
                                                            Sheyan
                                                </div>
                                                    </Typography>
                                                </ExpansionPanelDetails> */}
                                            </ExpansionPanel>
                                        </div>
                                    </div>
                                );
                            }

                            this.setState({ totalAsset: totalAsset });
                            this.setState({ assetA: assetA });

                            var liabilityA = [];
                            var totalLiability = 0;
                            for (var i = 0; i < response.data.detailObj.liability.length; i++) {

                                var dr = response.data.detailObj.liability[i].DR_SUM;
                                var cr = response.data.detailObj.liability[i].CR_SUM;

                                if (null == dr || '' == dr || undefined == dr) {
                                    dr = 0;
                                } else {
                                    dr = response.data.detailObj.liability[i].DR_SUM;
                                }

                                if (null == cr || '' == cr || undefined == cr) {
                                    cr = 0;
                                } else {
                                    cr = response.data.detailObj.liability[i].CR_SUM;
                                }

                                var sum = parseFloat(cr) - parseFloat(dr);
                                totalLiability = totalLiability + sum;

                                liabilityA.push(
                                    <div className="w-full">

                                        <div className="w-full">
                                            <ExpansionPanel expanded={this.state.expanded === 'panel1'} onChange={this.handleChange('panel1')}>
                                                <ExpansionPanelSummary className="emp-reg-expand-color-2">
                                                    <Typography className="{classes.heading} flex flex-wrap">
                                                        <label>{response.data.detailObj.liability[i].ACCOUNT_CATEGORY_NAME}</label>
                                                        <strong className="ml-16">{response.data.detailObj.liability[i].NAME}</strong></Typography>
                                                    <Typography className="{classes.secondaryHeading} ml-64">{sum}</Typography>
                                                </ExpansionPanelSummary>
                                            </ExpansionPanel>
                                        </div>
                                    </div>
                                );
                            }

                            this.setState({ totalLiability: totalLiability });
                            this.setState({ liabilityA: liabilityA });

                            var equityA = [];
                            var totalEquity = 0;
                            for (var i = 0; i < response.data.detailObj.equity.length; i++) {

                                var dr = response.data.detailObj.equity[i].DR_SUM;
                                var cr = response.data.detailObj.equity[i].CR_SUM;

                                if (null == dr || '' == dr || undefined == dr) {
                                    dr = 0;
                                } else {
                                    dr = response.data.detailObj.equity[i].DR_SUM;
                                }

                                if (null == cr || '' == cr || undefined == cr) {
                                    cr = 0;
                                } else {
                                    cr = response.data.detailObj.equity[i].CR_SUM;
                                }

                                var sum = parseFloat(cr) - parseFloat(dr);
                                totalEquity = totalEquity + sum;

                                equityA.push(
                                    <div className="w-full">

                                        <div className="w-full">
                                            <ExpansionPanel expanded={this.state.expanded === 'panel1'} onChange={this.handleChange('panel1')}>
                                                <ExpansionPanelSummary className="emp-reg-expand-color-2">
                                                    <Typography className="{classes.heading} flex flex-wrap">
                                                        <label>{response.data.detailObj.equity[i].ACCOUNT_CATEGORY_NAME}</label>
                                                        <strong className="ml-16">{response.data.detailObj.equity[i].NAME}</strong></Typography>
                                                    <Typography className="{classes.secondaryHeading} ml-64">{sum}</Typography>
                                                </ExpansionPanelSummary>
                                            </ExpansionPanel>
                                        </div>
                                    </div>
                                );
                            }

                            this.setState({ totalEquity: totalEquity });
                            this.setState({ equityA: equityA });
                            this.setState({ loading: false });

                        } else {
                            this.props.alert.error("No Data found");
                        }
                    }
                });
        }
    }

    // print balance Sheet
    printBalanceSheet() {

        this.setState({ loading: true });

        if (null == this.state.transactionDate || '' == this.state.transactionDate || undefined == this.state.transactionDate) {
            this.props.alert.error("Date Range Incorrect !");
            this.setState({ loading: false });
        } else {
            var address = null;

            // axios.get('http://localhost:5008/balanceSheetReport/getBalanceSheetReport', {
            axios.get(window.reportServer + '/balanceSheetReport/getBalanceSheetReport', {
                params: {
                    fromDate: '2018-01-01',
                    toDate: this.state.transactionDate
                }
            })
                .then(response => {
                    address = response.data.path;
                    address = window.reportServer + "/" + address;
                    // address = "http://localhost:5008/" + address;

                    //this.setState({ address: address });
                    console.log("asdkasjd ", address);
                    const url = address;
                    // window.open(url, '_blank');
                    printjs({ printable: address, type: 'pdf', showModal: true })
                    this.setState({ loading: false });
                }
                );
        }

    }

    render() {

        const { classes } = this.props;
        const { value } = this.state;
        const { expanded } = this.state;

        var equityM = () => {
            if (this.state.equityA.length == 0) {
                return { display: 'none', margin: 0 };
            } else {
                return { display: 'inline-block', margin: 0 };
            }
        }

        var liabilityM = () => {
            if (this.state.liabilityA.length == 0) {
                return { display: 'none', margin: 0 };
            } else {
                return { display: 'inline-block', margin: 0 };
            }
        }

        var assetM = () => {
            if (this.state.assetA.length == 0) {
                return { display: 'none', margin: 0 };
            } else {
                return { display: 'inline-block', margin: 0 };
            }
        }

        if (this.state.loading) {
            return (<Loader />);
        }
        else {
            return (
                <FusePageSimple
                    classes={{
                        root: classes.layoutRoot
                    }}

                    contentToolbar={
                        <div className="px-24"><h2 className="subtitle-color">Balance Sheet</h2></div>
                    }
                    content={
                        <div className="p-24 {classes.root}">
                            <div className="p-24 {classes.root} ">

                                <div className="flex flex-wrap -mx-3 mb-6">

                                    <div className="w-full md:w-1/5 inline-block">
                                        <p>Transaction Date</p>
                                        <DayPickerInput
                                            className="bg-orange"
                                            onDayChange={this.handleTransactionDateChange}
                                            selectedDays={this.state.transactionDate}
                                            value={this.state.transactionDate}
                                            onChange={this.handleTextBoxChange('transactionDate')}
                                        />
                                    </div>

                                    <div className="w-full md:w-3/5 float-right mb-16">

                                        <Button type="button" onClick={(ev) => this.getBalanceSheet()} variant="raised" color="secondary" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ledger-report-margin ">
                                            View
                                        </Button>

                                        <Button type="button" onClick={(ev) => this.sendEmail()} variant="raised" color="secondary" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ledger-report-margin  ">
                                            Email
                                         </Button>

                                        <Button type="button" onClick={(ev) => this.printBalanceSheet()} variant="raised" color="secondary" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ledger-report-margin ">
                                            Print
                                        </Button>

                                        <Button type="button" variant="raised" color="secondary" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 ledger-report-margin">
                                            Export
                                        </Button>
                                    </div>

                                </div>
                                <Divider className="md:mt-16 sm:mt-8 inter-acco-margin" />

                                <div className="flex flex-wrap -mx-3 mb-6">

                                    <div className="w-full md:w-4/5 inline-block"> </div>

                                    <div className="w-full md:w-1/5 inline-block">
                                        <label><strong>Industrial Calibration & Services Center (Pvt) Ltd</strong></label>
                                    </div>
                                </div>

                                <Divider className="md:mt-16 sm:mt-8" />
                            </div>


                            <div className="w-full flex flex-wrap">
                                <div className="w-full md:w-1/2 pr-16">
                                    <strong style={assetM()}>Asset</strong><br />
                                    {this.state.assetA}
                                    <strong style={assetM()}>TOTAL ASSET : {(this.state.totalAsset == 0) ? '' : this.state.totalAsset}</strong>
                                </div>


                                <div className="w-full md:w-1/2">
                                    <strong style={liabilityM()}>Liability</strong><br />

                                    {this.state.liabilityA}
                                    <strong style={liabilityM()}>TOTAL LIABILITY : {(this.state.totalLiability == 0) ? '' : this.state.totalLiability}</strong><br />

                                    <strong style={equityM()}>Equity</strong><br />

                                    {this.state.equityA}
                                    <strong style={equityM()}>TOTAL EQUITY : {(this.state.totalEquity == 0) ? '' : this.state.totalEquity}</strong>

                                </div>
                            </div>

                        </div>
                    }
                />
            );
        }
    }

}


export default withStyles(styles, { withTheme: true })(withAlert(BalanceSheet));


// WEBPACK FOOTER //
// ./src/main/content/accountingReports/balanceSheet/BalanceSheet.js